import { IonCard, IonCardContent, IonCheckbox, IonContent, IonDatetime, IonIcon, IonItem, IonLabel, IonList, IonPage, withIonLifeCycle } from "@ionic/react";
import moment from "moment";
import React from "react";
import AcrofitHeader from "../components/AcrofitHeader";
import db from "../components/Database";
import { updateAlarma } from "../components/Funciones";
import { get, post } from "../Rest";
import IAlarma from "../interfaces/IAlarma";
import icon_alarma from "../images/icon_alarma.svg"

class AlarmasPage extends React.Component{

    state = {
        alarma:{} as IAlarma
    }

    async ionViewDidEnter(){
        if(navigator.onLine){
            const {id} = await (await db.usuarios.toArray()).reduce(f => f)
            const local_data = await (await db.alarmas.toArray()).reduce(a => a)
            const server_data = await get("alarmas/"+id)
            if(!local_data.last_update || moment(local_data.last_update).isBefore(moment(server_data.last_update))){
              await db.alarmas.put(server_data)
            }
            else if(moment(server_data.last_update).isBefore(moment(local_data.last_update))){
              await post("alarmas",local_data)
            }
          }
          const alarma = await (await db.alarmas.toArray()).reduce(a => a)
          await this.setState({alarma})
          await updateAlarma()
    }

    onChange =  async (e:any) => {
      const {alarma} = this.state as any
      if(e.target.name === "activo"){
        alarma[e.target.name] = e.detail.checked?"1":"0"
      }else{
        alarma[e.target.name] = e.detail.value
      }
      alarma.last_update = moment().format("YYYY-MM-DD HH:mm:ss")
      if(navigator.onLine){
        await post("alarmas",alarma)
      }
      await db.alarmas.put(alarma)
      await this.setState({alarma})
      await updateAlarma()
    }

    render(){
        const {alarma} = this.state
        return (
            <IonPage>
                <AcrofitHeader />
                <IonContent className="no-bg">
                    <IonCard color="primary">
                        <IonCardContent>
                                <IonItem>
                                    <IonIcon icon={icon_alarma} slot="start" />
                                    <IonLabel>Desayuno</IonLabel>
                                    <IonDatetime cancelText="cancelar" onIonChange={this.onChange} value={alarma.desayuno} name="desayuno" pickerFormat="HH:mm" displayFormat="HH:mm" />
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonCard color="secondary">
                        <IonCardContent>
                                <IonItem>
                                    <IonIcon icon={icon_alarma} slot="start" />
                                    <IonLabel>Media mañana</IonLabel>
                                    <IonDatetime cancelText="cancelar" onIonChange={this.onChange} value={alarma.media_manana} name="media_manana" pickerFormat="HH:mm" displayFormat="HH:mm" />
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonCard color="tertiary">
                        <IonCardContent>
                                <IonItem>
                                    <IonIcon icon={icon_alarma} slot="start" />
                                    <IonLabel>Almuerzo</IonLabel>
                                    <IonDatetime cancelText="cancelar" onIonChange={this.onChange} value={alarma.almuerzo} name="almuerzo" pickerFormat="HH:mm" displayFormat="HH:mm" />
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonCard color="success">
                        <IonCardContent>
                                <IonItem>
                                    <IonIcon icon={icon_alarma} slot="start" />
                                    <IonLabel>Media tarde</IonLabel>
                                    <IonDatetime cancelText="cancelar" onIonChange={this.onChange} value={alarma.media_tarde} name="media_tarde" pickerFormat="HH:mm" displayFormat="HH:mm" />
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonCard color="warning">
                        <IonCardContent>
                                <IonItem>
                                    <IonIcon icon={icon_alarma} slot="start" />
                                    <IonLabel>Cena</IonLabel>
                                    <IonDatetime cancelText="cancelar" onIonChange={this.onChange} value={alarma.cena} name="cena" pickerFormat="HH:mm" displayFormat="HH:mm" />
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonCard color="danger">
                        <IonCardContent>
                                <IonItem>
                                    <IonCheckbox slot="start" color="danger" name="activo" checked={alarma.activo === "1"} onIonChange={this.onChange}  />
                                    <IonLabel>Activar alarma</IonLabel>
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                </IonContent>
            </IonPage>
        )
    }
}

export default withIonLifeCycle(AlarmasPage)